import { connect } from "react-redux";
import * as Redux from "redux";
import {
  flushReportFiles,
  getReportFiles,
  resendReportFile
} from "../../actions";
import ViewReportFile from "./component";
import { report_files_display } from "../../selectors";
import { ReportFile } from "../../constants";

export interface ViewReportFileProps {
  files: ReportFile[];
  match?: any;
}

export interface ViewReportFileActions {
  getReportFiles: (merchant_id: number) => void;
  flushReportFiles: () => void;
  resendReportFile: (
    merchant_id: number,
    report_id: number,
    report_file_id: number
  ) => void;
}

const mapStateToProps = (state: any): ViewReportFileProps => {
  return {
    files: report_files_display(state)
  };
};

const mapDispatchToProps = (
  dispatch: Redux.Dispatch<any>
): ViewReportFileActions => {
  return {
    ...Redux.bindActionCreators(
      { flushReportFiles, getReportFiles, resendReportFile },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewReportFile);



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReportFiles/container.ts